import { coreApi } from '$api'
import { LoadedLeaveRequestStatus } from '$constants'
import {
  ILeaveRequest,
  ILeaveType,
  LeaveRequest,
  LeaveRequestUpdateRequest,
} from '$models'

/**
 * Get Leave Request list
 * @param staffMemberId optional staff member id filter
 * @returns Promise<ILeaveRequest[]>
 */
export const getAll = async (
  staffMemberId?: string
): Promise<ILeaveRequest[]> => {
  const result = await coreApi.getLeaveRequests(staffMemberId)
  return result
}

/**
 * Add a new Leave Request
 * @param leaveRequest The Leave Request to create
 * @returns Promise<ILeaveRequest>
 */
export const add = async (
  leaveRequest: ILeaveRequest
): Promise<ILeaveRequest> => {
  const result = await coreApi.createLeaveRequest(leaveRequest as LeaveRequest)
  return result
}

/**
 * Send an existing leave request by Id
 * @param id Id of the leave request to send
 * @returns Promise<ILeaveRequest>
 */
export const sendRequest = async (id: string): Promise<ILeaveRequest> => {
  const result = await coreApi.sendLeaveRequest(id)
  return result
}

/**
 * Update a leave request status.
 * @param id Id of the leave request
 * @param status Status to update
 * @returns Promise<ILeaveRequest>
 */
export const updateStatus = async (
  id: string,
  status: LoadedLeaveRequestStatus
): Promise<ILeaveRequest> => {
  const payload = {
    status: status,
  } as LeaveRequestUpdateRequest

  const result = await coreApi.updateLeaveRequestStatus(id, payload)
  return result
}

export const getLeaveType = async (id: string): Promise<ILeaveType> => {
  const result = await coreApi.getLeaveTypeById(id)
  return result
}
